import { Application } from '@hotwired/stimulus';
import { PaymentMethodController } from '@inked/payment-method';
import { StripeExpressCheckoutController } from '@inked/stripe-express-checkout';
import { StripePaymentMethodController } from '@inked/stripe-payment-method';

const app = Application.start();

app.debug = process.env.NODE_ENV !== 'production';

app.register('payment-method', PaymentMethodController);
app.register('stripe-express-checkout', StripeExpressCheckoutController);
app.register('stripe-payment-method', StripePaymentMethodController);
